import { parse, ValiError } from 'valibot'
import type { FormValidatorFunc } from '@/types/form'
import { createEmptyFormFieldErrors, emptyTargetFields, normalizeValiError } from '@/utils/form'

export interface FormFields {
  keyword: string
  kindPokemon: boolean
  kindItem: boolean
  kindSupporter: boolean
  kindStadium: boolean
  kindPokemonTool: boolean
  kindBasicEnergy: boolean
  kindSpecialEnergy: boolean
  packId: number | null
  rarityId: string | null
  regulationName: string
  sellingPriceGte: number | null
  sellingPriceLte: number | null
}

export const getDefaultFields = (): FormFields => {
  return {
    keyword: '',
    kindPokemon: false,
    kindItem: false,
    kindSupporter: false,
    kindStadium: false,
    kindPokemonTool: false,
    kindBasicEnergy: false,
    kindSpecialEnergy: false,
    packId: null,
    rarityId: null,
    regulationName: '',
    sellingPriceGte: null,
    sellingPriceLte: null,
  }
}

export const formValidator: FormValidatorFunc<FormFields> = (fields, enableCheckFlg) => {

  let errors = createEmptyFormFieldErrors(fields)

  // valibotのschema validation
  try {
    // parse(ProfileSchema, { displayName, phoneNumber, zipCode, prefecture, address1, address2, address3 })
  } catch (e) {
    if (e instanceof ValiError) {
      errors = {
        ...errors,
        ...normalizeValiError(e)
      }
    }
  }
  const targetErrors = emptyTargetFields(errors, enableCheckFlg)

  return targetErrors
}
